import Brand from '../common/Brand';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { privacyApi, type PrivacyNotice } from '../../lib/api';
import { SafeGuideMarkdown } from '../guides/safeGuideMarkdown';

export default function PrivacyNoticePublic() {
  const { t, i18n } = useTranslation('common');
  const [notices, setNotices] = useState<PrivacyNotice[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    privacyApi.publicNotices(i18n.language)
      .then((payload) => setNotices(payload.notices || []))
      .catch(() => setError(t('privacy.loadFailed')));
  }, [i18n.language, t]);

  return (
    <div className="reading-page mx-auto max-w-3xl px-4 py-10">
      <div className="mb-8"><Brand /></div>
      <h1 className="mb-4 text-2xl font-semibold text-slate-900 dark:text-white">{t('privacy.publicTitle')}</h1>
      <p className="mb-6 text-sm text-slate-600 dark:text-slate-300">{t('privacy.publicIntro')}</p>
      {error && <p role="alert" className="text-sm text-red-700 dark:text-red-300">{error}</p>}
      <div className="space-y-6">
        {notices.map((notice) => (
          <section key={`${notice.slug}-${notice.locale}`} className="table-surface rounded-2xl border border-slate-200 p-5 dark:border-slate-700">
            <h2 className="mb-3 text-lg font-semibold text-slate-900 dark:text-white">{notice.title}</h2>
            <SafeGuideMarkdown text={notice.body} />
          </section>
        ))}
      </div>
      <Link to="/login" className="mt-6 inline-block text-sm font-semibold text-primary-700 dark:text-primary-300">
        {t('privacy.backToLogin')}
      </Link>
    </div>
  );
}
